<template>
  <div :class="{checkbox: type === 'checkbox', input: type !== 'checkbox'}">
    <label v-if="label && !reverse">{{label}}</label>
    <input :type="type || 'text'"  
          v-bind:value="value"
          v-on:input="$emit('input', $event.target.value)"
          v-on="listeners"
          v-bind="attrs"
          @keypress="validate"
          v-if="type !== 'checkbox'"
          />
    <input v-else  type="checkbox"
          :value="value"
          :checked="!!value"
          @change="$emit('input', $event.target.checked)"
      />
    <label v-if="label && reverse" style="margin-left: 5px">{{label}}</label>
  </div>
</template>

<script>
export default {
  props: ["label", "type", "value", "reverse"],
  methods: {
    validate(evt) {
      if (this.type === "number") {
        // safari doesn't respect types
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          this.$emit('keypress', evt);
          return true;
        }
      }
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    },
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },

}
</script>

<style scoped lang="less">
@import "../styles/main";
.checkbox {
  .input;
  flex-direction: row;
  align-items: center;
  label {
    margin-right: 5px;
  }
  input {
    margin-bottom: 5px;
  }
}

</style>
